import type { InjectionKey } from "vue";

const ErasingKey: InjectionKey<MaybeRefOrGetter<boolean>> =
  Symbol("erasingMode");
export const useEraser = () => {
  const provideErasingMode = (state: MaybeRefOrGetter<boolean>) =>
    provide(ErasingKey, state);

  const injectErasingMode = () => {
    return inject(ErasingKey) ?? ref(false);
  };

  return {
    provideErasingMode,
    injectErasingMode,
  };
};
